import { cn } from "@theprelude/core";

export const CrowdstrikeIcon: React.FC<
  React.ComponentPropsWithoutRef<"svg">
> = ({ className, ...props }) => (
  <svg
    className={cn("size-4 flex-shrink-0", className)}
    {...props}
    viewBox="0 0 16 16"
    fill="currentColor"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M15.2035 12.0833C14.8586 12.0494 14.2475 11.9637 13.4829 12.3495C12.7183 12.7353 12.4182 12.7512 12.0424 12.7113C12.153 12.9137 12.3763 13.1898 13.0791 13.2397C13.7819 13.2895 14.1179 13.3105 13.748 14.1857C13.757 13.9216 13.6942 13.4102 12.9974 13.4999C12.2996 13.5896 12.1371 14.2176 12.8847 14.5307C12.6415 14.5795 12.1261 14.6094 11.7583 13.6454C11.5031 13.7561 11.1093 13.9784 10.3955 13.4281C10.5617 13.4879 10.7471 13.5198 10.9518 13.5238C10.3188 13.2217 9.71364 12.6595 9.32685 12.1282C9.63389 12.3574 9.97283 12.5847 10.3158 12.6276C9.91003 12.1341 8.97396 11.1452 7.82754 10.1304C8.56424 10.6119 9.45346 11.3715 10.9089 11.2011C12.3644 11.0296 13.3423 10.6966 15.2035 12.0833Z"
      fill="currentColor"
    />
    <path
      d="M8.97396 11.7404C8.06181 11.3446 7.86642 11.2659 6.69308 10.9678C5.51975 10.6697 4.36536 10.0487 3.59377 9.08069C4.13807 9.47944 5.2486 10.2809 6.39003 10.1942C6.21657 9.94 5.89657 9.74262 5.51477 9.54324C5.94642 9.64692 7.25134 9.98088 8.97396 11.7404Z"
      fill="currentColor"
    />
    <path
      d="M3.75128 5.90461C0.734704 4.01951 0.135576 2.56704 0 2.00879C1.89508 4.08131 3.33458 4.89278 4.31452 5.54075C6.32822 6.82474 6.7529 7.68804 6.98816 8.36293C6.02218 6.99919 4.74318 6.5815 3.75128 5.90461Z"
      fill="currentColor"
    />
    <path
      d="M4.12611 7.39895C1.36573 5.93951 0.724735 4.77116 0.599128 4.23882C1.98081 5.71222 3.51701 6.48779 4.4172 6.99122C6.3671 8.03695 6.86455 8.77066 7.11178 9.34187C6.18268 8.2144 4.89072 7.81963 4.12611 7.39895Z"
      fill="currentColor"
    />
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M13.0602 9.28904C12.804 9.89814 13.0991 9.96592 13.2187 10.0118C13.8258 10.2441 15.4318 10.5421 15.3311 11.221C15.5185 11.4084 16.2123 12.1551 15.9222 12.6735C15.673 12.2667 14.5276 11.211 13.1419 10.9937C11.7563 10.7764 10.4932 11.2449 9.44947 10.5521C8.56324 9.91409 8.42069 9.67284 7.52847 8.21141C7.12773 7.55546 7.04997 6.95832 5.68922 5.84779C4.32847 4.73726 3.05545 4.14511 2.52112 2.49128C3.69047 3.92879 5.20274 5.3015 9.00386 6.3891C13.765 7.71695 13.4051 8.44767 13.0602 9.28904ZM15.1826 11.3735C15.1746 11.1103 15.2105 10.9578 14.4897 10.8482C14.7469 10.9751 14.9779 11.1502 15.1826 11.3735Z"
      fill="currentColor"
    />
  </svg>
);
